import myob from './myob';
import shift from './shift';
import getcapital from './getcapital';

const select = () => {
  // *register-myob.shiftpayments.com.au
  if (window.location.hostname.indexOf('myob.shiftpayments') > -1) {
    return myob;
  }

  // *register.shiftpayments.com.au
  if (window.location.hostname.indexOf('shiftpayments') > -1) {
    return shift;
  }

  // *register-admin.getcapital.com.au
  // *register.getcapital.com.au
  return getcapital;
};

export default {
  select,
};
